import React, { useCallback, useState } from 'react'
import SVGIcon from '../helpers/icons'
import useOperation from '../hooks/use-operation'
import usePortManager from '../hooks/use-port-manager'
import { observer } from 'mobx-react'
import PortInfo from './PortInfo'
import axios from 'axios'
import { mttAjax } from '../../../utils/_mtt-ajax'
import usePriceManager from '../hooks/use-price-manager'
import SimpleStepNav from '../navigation/SimpleStepNav'
import { checkoutState } from './OrderForm'
import useSettingsManager from '../hooks/use-settings-manager'
import Spinner from '../misc/Spinner'

export const AcceptTerms = observer(function AcceptTerms (props) {
  const settings_manager = useSettingsManager()
  const drawing_beslag_title = settings_manager.getOtherSettings(
    'checkout_accept_terms_text',
    'Jeg accepterer nassaus <a href=\'\'>salg og leveringsbetingelser.</a>'
  )
  const v = checkoutState.accept
  const sv = useCallback((e) => {
    checkoutState.setValue('accept', e.target.checked)
  }, [])
  return (
    <div className="accept-conditions">
      <input
        id="asdf"
        type="checkbox"
        name="fdsa"
        value="fdsa"
        checked={v}
        onChange={sv}
        required={true}
      />
      <label
        htmlFor={'asdf'}
        dangerouslySetInnerHTML={{ __html: drawing_beslag_title }}
      />
    </div>
  )
})

function PortOverview (props) {
  const operation = useOperation()
  const port_manager = usePortManager()
  const price_manager = usePriceManager()

  const [showall, setShowall] = React.useState(false)
  const [portAtts, setPortAtts] = React.useState(null)
  const fetchAtts = function () {
    let data = new FormData()
    data.append('action', 'nassau_port_config_portinfo')
    data.append('port', JSON.stringify(port_manager.currentPort))
    axios.post(
      window.main_theme_objects.ajax_url,
      data
    )
      .then(function (response) {
        if (response.status !== 200) return
        if (typeof response.data !== 'object') return
        setPortAtts(response.data)
        setShowall(false)
      })
  }

  if (portAtts === null) fetchAtts()

  const changePort = function (port_id) {
    port_manager.changePort(port_id)
    setPortAtts(null)
    fetchAtts()
  }

  const settings_manager = useSettingsManager()
  const afsend_ordre = settings_manager.getOtherSettings('submit_order_text', 'Afsend ordre')
  const se_alle_specifikationer = settings_manager.getOtherSettings('view_all_specs_text', 'Se alle specifikationer')
  const anslaaet_leveringstidspunkt = settings_manager.getOtherSettings('eta_text', 'Anslået leveringstidspunkt: 4-5 Uger')
  const port_oversigt = settings_manager.getOtherSettings('port_overview_title', 'Port oversigt')
  const payment_price_text = settings_manager.getOtherSettings('payment_price_text', 'Pris')
  const ekskl_moms = settings_manager.getOtherSettings('payment_ekskl_moms_text', 'ekskl. moms')
  const inkl_moms = settings_manager.getOtherSettings('payment_inkl_moms_text', 'inkl. moms')
  const [is_submitting_order, set_is_submitting_order] = useState(false)

  const checkout = useCallback(() => {
    set_is_submitting_order(true)
    let vat = port_manager.vat
    operation.save((d) => {
      if (d.success) {

        mttAjax('checkout_action', {
          action: 'checkout_action',
          'woocommerce-process-checkout-nonce': window.main_theme_objects.nonce,
          'billing_first_name': checkoutState.first_name,
          'billing_last_name': checkoutState.last_name,
          'billing_company': checkoutState.company,
          'billing_address_1': checkoutState.address,
          'billing_country': 'DK',
          'payment_method': checkoutState.payment_method,
          'billing_postcode': checkoutState.postal_code,
          'billing_city': checkoutState.city,
          'billing_phone': checkoutState.phone,
          'billing_email': checkoutState.email,
          'billing_vatnumber': checkoutState.vat_number,
          'shipping_method[0]': 'flat_rate:1',
          ship_to_different_address: checkoutState.ship_to_different_address ? 1 : 0,
          ...(checkoutState.ship_to_different_address ? {
            shipping_company: 'Gleason, Douglas and Volkman',
            'shipping_first_name': checkoutState.first_name,
            'shipping_last_name': checkoutState.last_name,
            'shipping_address_1': checkoutState.shipping_address,
            'shipping_postcode': checkoutState.shipping_postal_code,
            'shipping_city': checkoutState.shipping_city,
            'shipping_country': 'DK',
          } : {}),
          'is_b2b': true,
          'vat':vat
        }, (d) => {
          if (d.result === 'success') {
            if (d.redirect) {
              localStorage.removeItem('ports')
              localStorage.removeItem('current_port_id')
              document.location = d.redirect
            }
          } else {
            if (d.result === 'failure' && typeof d.messages === 'string') {
              checkoutState.error_message = d.messages
            } else {
              alert(JSON.stringify(d))
            }
          }
          set_is_submitting_order(false)
        })
      } else {
        alert(typeof d.data.error === 'string' ? d.data.error : 'something went wrong')//todo:handle errors better
        set_is_submitting_order(false)
      }
    })

  }, [])
  return (
    <div className={'port-overview'}>
      <div>
        <h2>{port_oversigt}</h2>
        <p>{anslaaet_leveringstidspunkt}</p>
        <div className={'port-overview-nav'}>
          {port_manager.ports.map((port, index) => (
            <button
              key={index}
              onClick={() => changePort(port.port_id)}
              data-active={(port_manager.currentPort.port_id === port.port_id).toString()}
            >
              {port.name}
            </button>
          ))}
        </div>
        <div className={'port-overview__order'}>
          <PortInfo showall={showall} atts={portAtts}/>
        </div>
        <button
          className={'link-button link-button--icon'}
          onClick={() => setShowall(!showall)}
        >
          <SVGIcon
            type={showall ? 'close-circle' : 'add-alt'}
            fill={'#000'}
            className={'link-button__icon'}
          />
          {se_alle_specifikationer}
        </button>
      </div>
      <div>
        <div className={'port-overview-prices'}>
          <div className={'port-overview-price'}>
            <div className={'port-overview-price__text'}>
              <span>{payment_price_text}</span> <span>{ekskl_moms}</span>
            </div>
            <div className={'port-overview-price__price'}
                 dangerouslySetInnerHTML={{ __html: price_manager.getTotalPrice()['price'] }}/>
          </div>
          <div className={'port-overview-price'}>
            <div className={'port-overview-price__text'}>
              <span>{payment_price_text}</span> <span>{inkl_moms}</span>
            </div>
            <div className={'port-overview-price__price'}
                 dangerouslySetInnerHTML={{ __html: price_manager.getTotalPrice()['price_vat'] }}/>
          </div>
        </div>
        <div className={'simple-step-nav'}>
          <SimpleStepNav next={false} nowrap={true}/>
          {is_submitting_order ? (
            <div className={'next button primary'} style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <Spinner color={'#FFFFFF'}/>
            </div>
          ) : (
            <button
              className={'next button primary'}
              onClick={checkout}
              disabled={!checkoutState.accept}
            >
              {afsend_ordre}
            </button>
          )}

        </div>
        <div className={'simple-step-nav'}>


        </div>
      </div>
    </div>
  )
}

export default observer(PortOverview)